import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { thunderstormATSGroups } from '../../consts.js';
import { ComponentSync } from '../../core/ComponentSync.js';
import { Grid } from '../Layouts/index.js';
import './ATS_CheckboxV2.scss';
import { TS_CheckboxV2 } from './TS_CheckboxV2.js';
import { voidFunction } from '@nu-art/ts-common';
class ATS_CheckboxV2_Class extends ComponentSync {
    render() {
        return _jsxs(Grid, { id: 'ats-checkbox-v2', onClick: () => console.log('Grid Click'), children: [this.render_Headers(), this.render_Enabled(), this.render_Disabled(), this.render_Free()] });
    }
    render_Headers = () => {
        return _jsxs(_Fragment, { children: [_jsx("div", { children: "State" }), _jsx("div", { children: "Checked" }), _jsx("div", { children: "Unchecked" }), _jsx("div", { children: "indeterminate" })] });
    };
    render_Enabled = () => {
        return _jsxs(_Fragment, { children: [_jsx("div", { children: "Enabled" }), _jsx(TS_CheckboxV2, { checked: true, label: 'text', onCheck: voidFunction }), _jsx(TS_CheckboxV2, { checked: false, label: 'text', onCheck: voidFunction }), _jsx(TS_CheckboxV2, { checked: undefined, label: 'text', onCheck: voidFunction })] });
    };
    render_Disabled = () => {
        return _jsxs(_Fragment, { children: [_jsx("div", { children: "Disabled" }), _jsx(TS_CheckboxV2, { checked: true, label: 'text', onCheck: voidFunction, disabled: true }), _jsx(TS_CheckboxV2, { checked: false, label: 'text', onCheck: voidFunction, disabled: true }), _jsx(TS_CheckboxV2, { checked: undefined, label: 'text', onCheck: voidFunction, disabled: true })] });
    };
    render_Free = () => {
        return _jsxs(_Fragment, { children: [_jsx("div", { children: "Test" }), _jsx(TS_CheckboxV2, { checked: this.state.checked, onCheck: checked => this.setState({ checked }), label: 'Text' })] });
    };
}
export const ATS_CheckboxV2 = {
    key: 'checkbox-v2',
    name: 'Checkbox V2',
    group: thunderstormATSGroups,
    renderer: ATS_CheckboxV2_Class,
};
//# sourceMappingURL=ATS_CheckboxV2.js.map